export default __webpack_public_path__ + "static/media/NIF_Award.9b8b4db4.png";